/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { OrgWithOAuthAppsTargetSpec } from './orgWithOAuthAppsTargetSpec';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';
import { DeploymentTargetSpec } from './deploymentTargetSpec';


/**
 * Specification for a rollout target.
 */
/**
 * @type RolloutTargetSpec
 * Specification for a rollout target.
 * @export
 */
export type RolloutTargetSpec = DeploymentTargetSpec | OrgWithOAuthAppsTargetSpec;

